import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/auth/AuthContext";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import EmailTemplates from "@/pages/EmailTemplates";
import AppShell from "@/layouts/AppShell";
import Dashboard from "@/pages/Dashboard";
import Dispos from "@/pages/Dispos";
import Planning from "@/pages/Planning";
import Heures from "@/pages/Heures";
import HeuresMonthly from "@/pages/HeuresMonthly";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import Profile from "@/pages/Profile";
import History from "@/pages/History";

const Protected = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#6b7f79]">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/"
            element={
              <Protected>
                <AppShell />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="dispos" element={<Dispos />} />
            <Route path="planning" element={<Planning />} />
            <Route path="heures" element={<Heures />} />
            <Route
              path="heures-mensuel"
              element={
                <Protected roles={["admin", "chef"]}>
                  <HeuresMonthly />
                </Protected>
              }
            />
            <Route
              path="equipe"
              element={
                <Protected roles={["admin", "chef"]}>
                  <Users />
                </Protected>
              }
            />
            <Route
              path="parametres"
              element={
                <Protected roles={["admin"]}>
                  <Settings />
                </Protected>
              }
            />
            <Route
              path="emails"
              element={
                <Protected roles={["admin"]}>
                  <EmailTemplates />
                </Protected>
              }
            />
            <Route
              path="historique"
              element={
                <Protected roles={["admin"]}>
                  <History />
                </Protected>
              }
            />
            <Route path="profil" element={<Profile />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
